// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"dacad4e1","171":"dacad4e1","278":"dacad4e1","350":"dacad4e1","687":"dacad4e1","928":"dacad4e1"}[chunkId] + ".chunk.css";
};